import { useDispatch } from 'react-redux'
import { setCurrentProfile } from '../actions/user'
import React from 'react'
import { useUser } from '../hooks/useUser'
import { ClassValue } from 'classnames/types'
import { EnhancedProfileSelect } from './profiles/DefaultProfileSelect'
import { idKey } from '../types/constants'
import Profile = Models.Profile

interface ProfileSelectProps {
    className?: ClassValue
}

export const ProfileSelect = ({ className }: ProfileSelectProps) => {
    const dispatch = useDispatch()
    const { hasKeys, profile, searchParams, profiles } = useUser()
    const urlSearchParams = new URLSearchParams(searchParams)
    const profileId = urlSearchParams.get('profileId')

    const profileFromQuery = profiles.find((p) => idKey(p.profile_id) === profileId)

    const selectedProfile =
        profiles.length == 0
            ? null
            : profileId === 'null' || !profileId || !profileFromQuery
              ? profile
              : profileFromQuery.profile_id

    if (!hasKeys) {
        return null
    }

    return (
        <EnhancedProfileSelect
            condensed
            className={className}
            buttonProps={{ minimal: true }}
            onChange={(profile) => dispatch(setCurrentProfile(profile.profile_id))}
            selectedProfileId={selectedProfile}
            filter={(profiles: Profile[]) => profiles.filter((p) => p.managed)}
        />
    )
}
